import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight, CheckCircle, Truck, Camera, Banknote, Refrigerator, Tv, Smartphone, Wind, WashingMachine, Microwave } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

const HomePage = () => {
  const phoneNumber = "05075537051";
  const whatsappNumber = "905075537051";
  const whatsappMessage = encodeURIComponent("Merhaba, eşya satmak istiyorum. Bilgi alabilir miyim?");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  const services = [
    {
      title: "İkinci El Beyaz Eşya Alan Yerler",
      description: "İstanbul'da ikinci el beyaz eşya alımında en güvenilir adres. Buzdolabı, çamaşır makinesi, bulaşık makinesi ve daha fazlası için en iyi fiyatları sunuyoruz.",
      icon: Refrigerator,
    },
    {
      title: "İkinci El Televizyon Alanlar",
      description: "Led TV, LCD TV, Smart TV, QLED TV ve Android TV dahil tüm televizyon modellerinizi değerinde satın alıyoruz.",
      icon: Tv,
    },
    {
      title: "İkinci El Elektronik Eşya Alanlar",
      description: "Ev elektroniği ve akıllı cihazlarınızı nakit karşılığında alıyoruz. Hızlı değerlendirme ve anında ödeme.",
      icon: Smartphone,
    },
    {
      title: "İkinci El Led TV Alan Yerler",
      description: "Tüm marka ve model LED televizyonlarınız için adil fiyat teklifi. Yerinde ekspertiz ve aynı gün ödeme imkanı.",
      icon: Tv,
    },
  ];

  const processSteps = [
    {
      step: 1,
      title: "Fotoğraf Gönderin",
      description: "WhatsApp üzerinden eşyanızın fotoğraflarını gönderin. Marka, model ve durumu belirtin.",
      icon: Camera,
    },
    {
      step: 2,
      title: "Teklif Alın",
      description: "Uzman ekibimiz fotoğrafları inceleyip size en uygun fiyat teklifini sunar.",
      icon: Banknote,
    },
    {
      step: 3,
      title: "Nakit Ödeme Alın",
      description: "Teklifi kabul ettiğinizde adresinize gelir, eşyayı alır ve nakit ödeme yaparız.",
      icon: Truck,
    },
  ];

  const products = [
    { name: "Buzdolabı", icon: Refrigerator },
    { name: "Çamaşır Makinesi", icon: WashingMachine },
    { name: "Bulaşık Makinesi", icon: WashingMachine },
    { name: "Klima", icon: Wind },
    { name: "Televizyon", icon: Tv },
    { name: "Led TV", icon: Tv },
    { name: "Smart TV", icon: Tv },
    { name: "Ankastre Set", icon: Microwave },
    { name: "Kurutma Makinesi", icon: WashingMachine },
    { name: "Ev Elektroniği", icon: Smartphone },
  ];

  const features = [
    "Sıfır, ikinci el ve defolu eşya alımı",
    "Anında nakit ödeme",
    "Ücretsiz ekspertiz hizmeti",
    "7/24 hizmet",
    "İstanbul genelinde servis",
    "Güvenilir ve profesyonel hizmet",
  ];

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section 
        className="relative min-h-[600px] md:min-h-[700px] flex items-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1721466288884-9b7f63b759d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpc3RhbmJ1bCUyMGNpdHlzY2FwZXxlbnwwfHx8fDE3NzUxMjYxNTd8MA&ixlib=rb-4.1.0&q=85')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        data-testid="hero-section"
      >
        <div className="hero-overlay absolute inset-0" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="max-w-2xl">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-4">
              İSTANBUL'UN GÜVENİLİR ADRESİ
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-none tracking-tight mb-6">
              İkinci El Beyaz Eşya ve Televizyonunuzu{" "}
              <span className="gradient-text">Değerinde Alıyoruz</span>
            </h1>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Sıfır, ikinci el veya defolu tüm beyaz eşya, televizyon ve elektronik eşyalarınızı nakit karşılığında satın alıyoruz. Hemen arayın veya WhatsApp'tan fotoğraf gönderin!
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a
                href={`tel:${phoneNumber}`}
                className="cta-primary text-center justify-center"
                data-testid="hero-phone-btn"
              >
                <Phone className="w-5 h-5" />
                <span>Hemen Ara: 0507 553 70 51</span>
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-whatsapp text-center justify-center"
                data-testid="hero-whatsapp-btn"
              >
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp'tan Resim Yolla</span>
              </a>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap gap-4">
              {["7/24 Hizmet", "Anında Nakit", "Ücretsiz Ekspertiz"].map((badge) => (
                <div key={badge} className="flex items-center gap-2 text-slate-600 text-sm">
                  <CheckCircle className="w-4 h-4 text-[#128C7E]" />
                  <span>{badge}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - SEO Keywords */}
      <section className="py-16 md:py-24 bg-slate-50" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
              HİZMETLERİMİZ
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              İkinci El Eşya Alım Hizmetlerimiz
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              İstanbul genelinde ikinci el beyaz eşya, televizyon ve elektronik eşya alımı yapıyoruz. Profesyonel ve güvenilir hizmet anlayışımızla yanınızdayız.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {services.map((service, index) => (
              <Card key={index} className="card-hover border border-slate-200 bg-white" data-testid={`service-card-${index}`}>
                <CardContent className="p-6">
                  <div className="flex gap-4">
                    <div className="service-icon flex-shrink-0">
                      <service.icon className="w-7 h-7" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg text-slate-900 mb-2">{service.title}</h3>
                      <p className="text-slate-600 text-sm leading-relaxed">{service.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* SEO Keywords Tags */}
          <div className="mt-12 text-center">
            <div className="flex flex-wrap justify-center gap-2">
              {[
                "İkinci el beyaz eşya alan yerler",
                "İkinci el beyaz eşya alanlar",
                "İkinci el televizyon alan yerler",
                "İkinci el televizyon alanlar",
                "İkinci el led tv alan yerler",
                "İkinci el led tv alanlar",
                "İkinci el elektronik eşya alan yerler",
                "İkinci el elektronik eşya alanlar",
              ].map((keyword) => (
                <span key={keyword} className="seo-tag">{keyword}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 md:py-24" data-testid="process-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
              NASIL ÇALIŞIR?
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              3 Kolay Adımda Eşyanızı Satın
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Eşyanızı satmak çok kolay! WhatsApp üzerinden fotoğraf gönderin, teklif alın ve nakit ödemenizi kapınızda teslim alın.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {processSteps.map((item) => (
              <div key={item.step} className="text-center" data-testid={`process-step-${item.step}`}>
                <div className="flex justify-center mb-4">
                  <div className="step-number">{item.step}</div>
                </div>
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
                    <item.icon className="w-8 h-8 text-[#002FA7]" />
                  </div>
                </div>
                <h3 className="font-semibold text-lg text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm">{item.description}</p>
              </div>
            ))}
          </div>

          {/* CTA after process */}
          <div className="mt-12 text-center">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cta-whatsapp inline-flex"
              data-testid="process-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Hemen WhatsApp'tan Başlayın</span>
            </a>
          </div>
        </div>
      </section>

      {/* Products We Buy Section */}
      <section className="py-16 md:py-24 bg-slate-50" data-testid="products-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
              SATIN ALDIĞIMIZ EŞYALAR
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              Hangi Eşyaları Satın Alıyoruz?
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Aşağıdaki ürün kategorilerinde sıfır, ikinci el ve defolu tüm eşyalarınızı nakit karşılığında satın alıyoruz.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            {products.map((product, index) => (
              <div
                key={index}
                className="category-badge flex-col gap-2 p-4 text-center cursor-pointer"
                data-testid={`product-badge-${index}`}
              >
                <product.icon className="w-8 h-8 text-[#002FA7]" />
                <span className="font-medium">{product.name}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <Link to="/satin-aldigimiz-esyalar" className="inline-flex items-center gap-2 text-[#002FA7] font-semibold hover:underline">
              Tüm Ürün Kategorilerini Görün
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 md:py-24" data-testid="why-us-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
                NEDEN BİZ?
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-6">
                Güvenilir ve Profesyonel Hizmet
              </h2>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Yıllardır İstanbul'da ikinci el beyaz eşya, televizyon ve elektronik eşya alım satımı yapıyoruz. Müşteri memnuniyeti odaklı çalışma anlayışımızla binlerce kişiye hizmet verdik.
              </p>
              <ul className="space-y-3 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3" data-testid={`feature-${index}`}>
                    <CheckCircle className="w-5 h-5 text-[#128C7E] flex-shrink-0" />
                    <span className="text-slate-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href={`tel:${phoneNumber}`}
                className="cta-primary inline-flex"
                data-testid="why-us-phone-btn"
              >
                <Phone className="w-5 h-5" />
                <span>Hemen Arayın: 0507 553 70 51</span>
              </a>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxob21lJTIwYXBwbGlhbmNlc3xlbnwwfHx8fDE3NzUxMjYxNTd8MA&ixlib=rb-4.1.0&q=85"
                alt="Modern mutfak beyaz eşyaları"
                className="rounded-2xl shadow-xl w-full object-cover h-[400px]"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#002FA7] text-white p-6 rounded-xl shadow-lg">
                <p className="text-3xl font-bold">7/24</p>
                <p className="text-sm">Hizmetinizdeyiz</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-[#002FA7]" data-testid="cta-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">
            Eşyanızı Hemen Nakite Çevirin!
          </h2>
          <p className="text-blue-100 text-lg mb-8">
            WhatsApp üzerinden eşyanızın fotoğraflarını gönderin, dakikalar içinde teklif alın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${phoneNumber}`}
              className="inline-flex items-center justify-center gap-2 bg-white text-[#002FA7] px-6 py-3.5 rounded-lg font-semibold hover:bg-slate-100 transition-colors"
              data-testid="cta-phone-btn"
            >
              <Phone className="w-5 h-5" />
              <span>0507 553 70 51</span>
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-[#128C7E] transition-colors"
              data-testid="cta-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp'tan Yaz</span>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Preview Section */}
      <section className="py-16 md:py-24" data-testid="faq-preview-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
              SIK SORULAN SORULAR
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-4">
              Merak Edilenler
            </h2>
          </div>

          <div className="space-y-4">
            {[
              {
                q: "Hangi eşyaları satın alıyorsunuz?",
                a: "Buzdolabı, çamaşır makinesi, bulaşık makinesi, televizyon, klima ve tüm ev elektroniği ürünlerini satın alıyoruz.",
              },
              {
                q: "Ödeme nasıl yapılıyor?",
                a: "Eşyanızı adresinizden aldığımızda nakit ödeme yapıyoruz. Anında ve güvenli ödeme garantisi.",
              },
              {
                q: "Defolu eşya alıyor musunuz?",
                a: "Evet, sıfır, ikinci el ve defolu tüm eşyaları değerlendirip satın alıyoruz.",
              },
            ].map((faq, index) => (
              <div key={index} className="bg-slate-50 rounded-lg p-6" data-testid={`faq-preview-${index}`}>
                <h3 className="font-semibold text-slate-900 mb-2">{faq.q}</h3>
                <p className="text-slate-600 text-sm">{faq.a}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <Link to="/sss" className="inline-flex items-center gap-2 text-[#002FA7] font-semibold hover:underline">
              Tüm Soruları Görün
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
